import { API_V1_PATH } from "../config";
import { request } from "../request";
export const searchDocuments = ({ query, limit = 10, signal }) => {
    const searchParams = new URLSearchParams({
        query,
        limit: String(limit)
    });
    return request(`${API_V1_PATH}/search?${searchParams}`, {
        method: "GET",
        signal
    });
};
